import { useMutation, useQueryClient } from '@tanstack/react-query'

import { contentKeys } from '../queryKeys'
import { moveNode } from '..'

const useMoveNodeMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: moveNode,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: contentKeys.nodes() })
    },
  })
}

export default useMoveNodeMutation
